<section class="stickeySection__">
  <section class="filter_section_" *ngIf="!isBookingLoader">
    <div class="top_header_">
      <!-- <p>Search Results: <ng-container *ngIf="!(loaderService.isLoading | async)"><span><ng-container *ngFor="let tot_r of list; let i = index"><span>{{tot_r.totalFlight}}{{i < list.length - 1 ? ',' : ''}}</span></ng-container></span></ng-container></p> -->
      <p><span>Choose your Preferred Flight:</span> <ng-container *ngIf="!(loaderService.isLoading | async)"> {{this.trip_type?.one_way?.search_request?.origin?.city_name}}<span>-</span>{{this.trip_type?.one_way?.search_request?.destination?.city_name}}<span>-</span>{{this.trip_type?.one_way?.search_request?.origin?.city_name}}</ng-container></p>
      <div class="space"></div>
      <button mat-button color="primary" (click)="filter = !filter"><mat-icon color="primary">filter_alt</mat-icon> Filter</button>
    </div>
  </section>
</section>
<section class="list_flight_section_ round_list_section">
  <ng-container *ngIf="isLoading">
    <app-flight-round-way-loader></app-flight-round-way-loader>
    <!-- <app-flight-result-loader></app-flight-result-loader> -->
  </ng-container>
  <ng-container  *ngIf="!isLoading">
    <section class="listSection_wrapper" *ngIf="this.list[0]?.totalFlight !== 0 || this.list[1]?.totalFlight !== 0">
      <ng-container *ngFor="let item_ of list; let j = index">

        <div class="list_inner_wrapper filter_section_">
          <section class="stickeySection__">
            <ng-container *ngIf="filter">
              <mat-card class="matcardWrapper">
              <mat-tab-group dynamicHeight animationDuration="0ms">
                <mat-tab>
                  <ng-template matTabLabel>Price / Airlines</ng-template>
                  <div class="wrapper_mat_card__">
                    <div class="inner_card_wrapper_ filterDesign_">
                      <div class="filter_header">
                        <h4>Price</h4>
                        <div class="filter_amount_">
                          <ngx-slider 
                          [highValue]="getMaxValue(item_.name)" 
                          [options]="options" 
                          (userChangeEnd)="onValueChange($event, item_.name)">
                        </ngx-slider>
                          <div class="price_value">
                            <p>
                              <span>{{ getMinValue(item_.name) | currency: 'INR' }}</span>
                              <span>{{ getMaxValue(item_.name) | currency: 'INR' }}</span>
                            </p>
                          </div>
                          <div class="filter_stops">
                            <p>Stops:</p>
                            <ul>
                              <li *ngFor="let list of item_.stopsList; let y = index" [value]="list" [class.active]="activeStates[j][y].isSelected" (click)="selectStop(list, item_.name)">{{list.value}}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="inner_card_wrapper_ filterDesign_">
                      <div class="filter_header">
                        <h4>Airlines</h4>
                      </div>
                      <div class="flight_list_">
                        <ul>
                          <li *ngFor="let item of item_.uniqueCarrier['list']; let i = index">
                            <mat-checkbox color="primary" [matTooltip]="item.name" (click)="filter_airline(item, item_.name)">{{item.name}}</mat-checkbox>
                          </li>
                          <li *ngIf="item_.uniqueCarrier.list.length > 5" class="view_more_btn">
                            <button mat-button color="primary" (click)="airlinelist(item_.uniqueCarrier)">View More</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template matTabLabel>Depart Time / Arrive Time</ng-template>
                  <div class="wrapper_mat_card__">
                    <div class="inner_card_wrapper_ filterDesign_">
                      <div class="filter_header">
                        <h4>Depart Time</h4>
                      </div>
                      <div class="time_list_item">
                        <ul>
                          <ng-container *ngFor="let item of item_.flightTime['departTime']  let y = index">
                            <li (click)="selectDepart(item, item_.name)" [class.active]="activeTimedep[j][y].isSelected" > 
                              <div class="time_layout_">
                                <div class="img_icon">
                                  <img [src]="item.imgIcon" [alt]="item.name" class="img-fluid">
                                </div>
                                <p>{{item.time}}</p>
                              </div>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                    <div class="inner_card_wrapper_ filterDesign_">
                      <div class="filter_header">
                        <h4>Arrive Time</h4>
                      </div>
                      <div class="time_list_item">
                        <ul>
                          <ng-container *ngFor="let item of item_.flightTime['arrivalTime'] let y = index">
                            <li (click)="selectArrival(item, item_.name)" [class.active]="activeTime[j][y].isSelected_"> 
                              <div class="time_layout_">
                                <div class="img_icon">
                                  <img [src]="item.imgIcon" [alt]="item.name" class="img-fluid">
                                </div>
                                <p>{{item.time}}</p>
                              </div>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
              </mat-card>
              
            </ng-container>
            <!-- Round Trip Header desing -->
            <section class="list_header_section">
              <div class="top_header">
                <div class="search_name_">
                  <p>{{item_.requestSearch.origin}}&nbsp;<mat-icon>trending_flat</mat-icon>&nbsp;{{item_.requestSearch.destination}}</p>
                </div>
                <div class="space"></div>
                <!-- <div class="date_search"><p>{{item_.requestSearch.onwarddate | date: 'dd MMM, cccc'}}</p></div> -->
                <div class="date_search"> <p [ngClass]="{'mobile-view': isMobileView}">
                  {{ item_.requestSearch.onwarddate | date: isMobileView ? 'dd MMM, EEE' : 'dd MMM, cccc' }}
                </p></div>
              </div>
              <div class="listshortjing">
                <section class="shorting_section">
                  <div class="shoting_">
                    <div class="list_shorting list_">
                      <p>Sort By:</p>
                    </div>
                    <div class="list_shorting list_">
                      <div class="timing_shorting_">
                        <div class="list_ list_" (click)="sortByDepartureTime(item_.name)"><button mat-button>Depart</button></div>
                        <div class="list_ list_Duration" (click)="sortByDuration(item_.name)"><button mat-button>Duration</button></div>
                        <div class="list_ list_Arrive" (click)="sortByArrivalTime(item_.name)"><button mat-button>Arrive</button></div>
                      </div>
                    </div>
                    <div class="list_shorting list_">
                      <button mat-button (click)="sortByPrice(item_.name)">Price</button>
                    </div>
                  </div>
                </section>
              </div>
            </section>
          </section>
          <!-- Round trip list design -->
          <section class="round_list_section_list_">
            <ng-container *ngFor="let item of item_['flightlist']; let i = index">
              <mat-card class="matCard_flight_list" *ngIf="item.name === 'flight'" [ngClass]="{'selected': isSelected(j, i)}" (click)="select([item_, item])" (click)="select__([j, i])">
                <div class="_flight_list">
                  <div class="flight_list">
                    <div class="iconContent">
                      <img src="https://air.belairtrip.com/img/air_logos/{{item['flightlegs'][0][0].carrier}}.png" [alt]="item['flightlegs'][0][0].carriername" class="img-fluid" onError="this.src='../../../../assets/b2c/flight/flight_icon.png'"/>
                      <div class="content">
                        <h4>{{item['flightlegs'][0][0].carriername}}</h4>
                        <p><ng-container *ngFor="let carrNo of item['flightlegs'][0]">{{carrNo.carrier}}-{{carrNo.flightnumber}}&nbsp;</ng-container></p>
                      </div>
                    </div>
                  </div>
                  <div class="flight_list">
                    <div class="timing_flight_">
                      <div class="list_ list_Depart">
                        <p class="time">{{item['flightlegs'][0][0].deptime | hourMinute}}</p>
                        <!-- <p class="cityDate">{{item['flightlegs'][0][0].depdate}}</p> -->
                        <p class="cityName">{{item['flightlegs'][0][0].origin_name}}</p>
                      </div>
                      <div class="list_ list_Duration">
                        <div class="duration">
                          <p class="timeDuration">{{item | addLayoverDuration | formatTime}}</p>
                          <div class="distpoint">
                            <span class="line"></span>
                            <ng-container *ngFor="let list of item['flightlegs'][0]">
                              <span></span>
                            </ng-container>
                          </div>
                          <p class="stopage">
                            <ng-container *ngIf="item.layovers[0].length !== 0">{{item['flightlegs'][0].length - 1}} stop via</ng-container>
                            <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                              <ng-container>&nbsp;{{list.key}}</ng-container>
                            </ng-container>
                            <ng-container *ngIf="item.layovers[0].length === 0">Direct Flight</ng-container>
                          </p>
                        </div>
                      </div>
                      <div class="list_ list_Arrive">
                        <p class="time">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].arrtime | hourMinute}}</p>
                        <!-- <p class="cityDate">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].arrdate}}</p> -->
                        <p class="cityName">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].destination_name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="flight_list">
                    <p class="flight_fare">{{item.flightfare.totalnet | globalCurrency : this.Xchangerates.getCurrency().shortname}}</p> <!-- : true : '2.0-0'-->
                  </div>
                </div>
                <div class="moreInfoFlight">
                  <div class="more_info_details">
                    <ul>
                      <li class="meal_info_" *ngIf="(item | extractValidatingCarrier)?.includes('AI')"><span> <mat-icon>restaurant</mat-icon>Complimentary Meals</span></li>
                    </ul>
                    <!-- <ul *ngIf="item.extra_info.length !== null">
                      <li><span *ngIf="item.extra_info.hand_baggage.length > 0"> <ng-container *ngIf="item.extra_info.hand_baggage[0].value === true"><mat-icon>business_center</mat-icon>Allow&nbsp;Hand (B)</ng-container></span><span class="non_refundable" *ngIf="item.extra_info.hand_baggage.length === 0"><mat-icon>work_off</mat-icon>No Hand (B)</span></li>
                      <li><span *ngIf="item.extra_info.baggage.length > 0"><mat-icon>luggage</mat-icon>{{item.extra_info.baggage[0].value}}&nbsp;Check In (B)</span><span *ngIf="item.extra_info.baggage.length === 0"><mat-icon>no_luggage</mat-icon>No Baggage</span></li>
                      <li class="fundInfo" ngClass="{{item.extra_info.refundable === true ? 'refundable' : item.extra_info.refundable === false ? 'non_refundable' : item.extra_info.refundable}}" (click)="flightInfo(j, i)">
                        {{item.extra_info.refundable === true ? 'REFUNDABLE' : item.extra_info.refundable === false ? 'NON REFUNDABLE' : item.extra_info.refundable}}
                      </li>
                    </ul> -->
                  </div>
                  <div class="space"></div>
                  <button mat-button class="flight_detatils" (click)="flightInfo(j, i)">{{ flight_Details[j] && flight_Details[j][i] ? 'Hide' : 'View' }}&nbsp;Flight Details</button>
                </div>
                <section class="moreInformationFlight" [ngClass]="{'d-block': flight_Details[j] && flight_Details[j][i]}">
                  <mat-tab-group dynamicHeight animationDuration="0ms" [selectedIndex]="0">
                    <mat-tab>
                      <ng-template mat-tab-label>Flight Details</ng-template>
                      <div class="flight_tab_list_details">
                        <div class="innerWrapper">
                          <div class="flight_deatils_info">
                            <h3>Flight Details</h3>
                            <div class="more_flight_details">
                              <ng-container *ngFor="let listItem of item['flightlegs'][0]">
                                <div class="flight_header_">
                                  <div class="flight_info_">
                                    <div class="iconContent">
                                      <img src="https://air.belairtrip.com/img/air_logos/{{listItem.carrier}}.png" [alt]="listItem.carriername" class="img-fluid" onError="this.src='../../../../assets/b2c/flight/flight_icon.png'"/>
                                      <div class="content">
                                        <h4>{{listItem.carriername}}</h4>
                                        <p>{{listItem.carrier}}-{{listItem.flightnumber}}&nbsp;</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="more_info_extra"><p class="mb-1"><span><mat-icon>business_center</mat-icon><!--{{item.extra_info.hand_baggage[0].value}}--><strong>Cabin Baggage:&nbsp;</strong>7Kg (1 Piece Only)/ Adult</span></p><p><span *ngIf="item.extra_info.baggage.length > 0"><mat-icon>luggage</mat-icon><strong>Check-in Baggage:&nbsp;</strong>{{item.extra_info.baggage[0].value | transformUnit}}/ Adult<!--&nbsp;Check In Baggage--></span></p></div> <!--*ngIf="item.extra_info.hand_baggage.length > 0"-->
                                </div>
                                <div class="flight_body_">
                                  <div class="timing_flight_">
                                    <div class="list_ list_Depart">
                                      <p class="cityName">{{listItem.origin_name}}</p>
                                      <p class="time">{{listItem.deptime | hourMinute}}</p>
                                      <p class="cityDate">{{listItem.depdate | date: 'LLL, dd yyyy'}}</p>
                                      <p class="terminal" *ngIf="listItem.depterminal !== ''">Terminal {{listItem.depterminal}}</p>
                                    </div>
                                    <div class="list_ list_Duration">
                                      <div class="duration">
                                        <img src="../../../../assets/belairtrip_assets/svg_icon/clockicon.svg" alt="" class="img-fluid clock">
                                        <p class="timeDuration">{{listItem.journeyduration | formatTime}}</p>
                                        <div class="distpoint">
                                          <span class="line"></span>
                                        </div>
                                        <p class="stopage">
                                          <!-- <ng-container *ngIf="item.layovers[0].length !== 0">{{item['flightlegs'][0].length - 1}} stop via</ng-container>
                                          <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                                            <ng-container>&nbsp;{{list.key}}</ng-container>
                                          </ng-container>
                                          <ng-container *ngIf="item.layovers[0].length === 0">Direct Flight</ng-container> -->
                                        </p>
                                      </div>
                                    </div>
                                    <div class="list_ list_Arrive">
                                      <p class="cityName">{{listItem.destination_name}}</p>
                                      <p class="time">{{listItem.arrtime | hourMinute}}</p>
                                      <p class="cityDate">{{listItem.arrdate | date: 'LLL, dd yyyy'}}</p>
                                      <p class="terminal" *ngIf="listItem.depterminal !== ''">Terminal {{listItem.arrterminal}}</p>
                                    </div>
                                  </div>
                                </div>
                                <!-- Layover -->
                                <ng-container *ngIf="listItem.stopover === true">
                                  <div class="layover">
                                    <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                                      <ng-container *ngIf="list.key === listItem.destination">
                                        <p>Flight change · Layover&nbsp;&nbsp;<span>{{this.util.convertToNumber(list.value) | secondsToDHM}}&nbsp;({{listItem.destination}})</span></p>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>Fare Summary</ng-template>
                      <div class="flight_tab_list_details">
                        <div class="innerWrapper fare_information">
                          <div class="flight_fare_info">
                            <h3>Fare Summary</h3>
                            <div class="more_info_fare">
                              <ul>
                                <li>Base Fare: <span>{{ (this.adultNum * item.flightfare.adultbasefare) + (this.childNum * item.flightfare.childbasefare) + (this.infantNum * item.flightfare.infantbasefare) | globalCurrency: item.flightfare.currency }}</span></li>
                                <li>Fee & Surcharges: <span>{{ (this.adultNum * item.flightfare.adulttax) + (this.childNum * item.flightfare.childtax) + (this.infantNum * item.flightfare.infanttax) | globalCurrency: item.flightfare.currency }}</span></li>
                                <li>Total Amount: <span>{{item.flightfare.totalnet | globalCurrency: item.flightfare.currency}}</span></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab *ngIf="!(item | extractValidatingCarrier)?.includes('')">
                      <ng-template mat-tab-label>Fare Rules</ng-template>
                      <div class="flight_tab_list_details">
                        <div class="innerWrapper fare_information">
                          <div class="flight_fare_rule">
                            <div class="d-flex justify-content-between align-items-baseline">
                              <h3 class="w-100 d-flex justify-content-between align-items-center">Fare Rules
                                <div class="fundInfo" ngClass="{{item.extra_info.refundable === true ? 'refundable' : item.extra_info.refundable === false ? 'non_refundable' : item.extra_info.refundable}}">
                                  {{item.extra_info.refundable === true ? 'REFUNDABLE' : item.extra_info.refundable === false ? 'NON REFUNDABLE' : item.extra_info.refundable}}
                                </div></h3>
                            </div>
                            <div class="more_info_rule">
                              <ul>
                                <li *ngIf="item.extra_info.cancel.length > 0">Airline Cancellation Fee: <span>{{item.extra_info.cancel[0].value | globalCurrency: item.flightfare.currency}}</span>
                                  <p>{{item.extra_info.cancel[0].rule}}</p>
                                </li>
                                <li *ngIf="item.extra_info.change.length > 0">Airline Date Change Fee: <span>{{item.extra_info.change[0].value | globalCurrency: item.flightfare.currency}}</span>
                                  <p>{{item.extra_info.change[0].rule}}</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                </section>
              </mat-card>
              <ng-container *ngIf="item.name === 'banner'">
                <mat-card class="flight_list_banner">
                  <div class="banner_list">
                    <div class="bannerImageWrapper">
                      <img [src]="item.banner_image" [alt]="item.banner_airline_name" class="img-fluid" appCheckDomain>
                    </div>
                    <div class="bannerContent"></div>
                  </div>
                </mat-card>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="item_['flightlist'].length === 0">
              <app-no-flight *ngIf="!isLoading"></app-no-flight>
            </ng-container>
          </section>
        </div>
      </ng-container>
    </section>
    <ng-container *ngIf="!isLoading && !noFlightError">
      <section [class.moreinfoFlight]="showMoreInfo"  class="selected_flight_section flight_selected_" *ngIf="this.list[0]?.totalFlight !== 0 || this.list[1]?.totalFlight !== 0" (clickOutside)="closeMoreInfo()" >
        <div class="container">
          <mat-card>
            <div class="list_wrapper">
              <div class="list_inner mobileView">
                <ng-container *ngFor="let lists of select_list">
                  <div class="list_selected_Flight">
                    <h3 class="heading_title">{{lists.title}}</h3>
                    <ng-container *ngFor="let item of lists['list']">
                      <div class="flight_data_list">
                        <div class="flight_list_info">
                          <div class="iconContent">
                            <img src="https://air.belairtrip.com/img/air_logos/{{item['flightlegs'][0][0].carrier}}.png" [alt]="item['flightlegs'][0][0].carriername" class="img-fluid" onError="this.src='../../../../assets/b2c/flight/flight_icon.png'"/>
                            <div class="content">
                              <h4>{{item['flightlegs'][0][0].carriername}}</h4>
                              <span class="FlightDetailsButton" (click)="toggleMoreInfo($event)">Flight Details</span>
                              <!-- <p><ng-container *ngFor="let carrNo of item['item'][0]">{{carrNo.carrier}}-{{carrNo.flightnumber}}&nbsp;</ng-container></p> -->
                            </div>
                          </div>
                          <div class="timeSloat">
                            <p class="time"><span><span class="flightlegsName">{{item['flightlegs'][0][0].origin}}</span><br>{{item['flightlegs'][0][0].deptime | hourMinute}}</span>&nbsp;&nbsp;&nbsp;<mat-icon>trending_flat</mat-icon>&nbsp;&nbsp;&nbsp;<span><span class="flightlegsName">{{item['flightlegs'][0][item['flightlegs'][0].length - 1].destination}}</span><br>{{item['flightlegs'][0][item['flightlegs'][0].length - 1].arrtime | hourMinute}}</span></p>
                          </div>
                          <div class="priceSloat"><p>{{item.flightfare.totalnet | globalCurrency: item.flightfare.currency}}</p></div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <div class="list_inner list_selected_Flight">
                <h3 class="heading_title">Total Amount</h3>
                <p class="finalPrice">{{this.select_list[0].list[0].flightfare.totalnet + this.select_list[1].list[0].flightfare.totalnet | globalCurrency: this.select_list[0].list[0].flightfare.currency}}</p>
              </div>
              <div class="list_inner">
                <button mat-button color="primary" class="submitBtn" (click)="submit()" [disabled]="flightOccursBefore">Book Now</button>
                <button mat-icon-button color="primary" class="submitBtnUPDOWN" (click)="toggleMoreInfo($event)"><mat-icon>{{ showMoreInfo ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon></button>
              </div>
            </div>
          </mat-card>
          <ng-container>
            <div [class.moreinfoFlight]="showMoreInfo" class="FlightDetailsList">
              <section class="FlightmoreDetileList">
                <div class="heading">
                  <div class="flightDetailsNav">
                    <ul>
                      <li class="FlightDetails" [class.active]="activeTab === 'FlightDetails'" (click)="selectTab('FlightDetails')">Flight Details</li>
                      <li class="FareSummary" [class.active]="activeTab === 'FareSummary'"  (click)="selectTab('FareSummary')">Fare Summary</li>
                      <li class="FareRules" [class.active]="activeTab === 'FareRules'" (click)="selectTab('FareRules')">Fare Rules</li>
                    </ul>
                  </div>
                </div>
                <section class="flightDetileListSection">
                  <ng-container *ngFor="let item_ of select_list">
                    <div class="list_wrapper">
                      <ng-container *ngFor="let item of item_['list'][0]['flightlegs']" >
                        <div class="journeyheader">
                          <div class="search_name_">
                            <p>{{item[0].origin_name}}&nbsp;<mat-icon>trending_flat</mat-icon>&nbsp;{{item[item.length - 1].destination_name}}</p>
                          </div>
                          <div class="space"></div>
                          <div class="search_name_ date_search"><p>{{item[0].depdate | date: 'dd MMM, cccc'}}</p></div>
                        </div>
                      </ng-container>
                      <ng-container *ngFor="let item of item_['list'][0]['flightlegs']">
                        <div class="headerFlightSelect FlightDetailsSelect" *ngIf="activeTab === 'FlightDetails'">
                          <div class="more_flight_details">
                            <ng-container *ngFor="let listItem of item_['list'][0]['flightlegs'][0]">
                              <div class="flight_header_">
                                <div class="flight_info_">
                                  <div class="iconContent">
                                    <img src="https://air.belairtrip.com/img/air_logos/{{listItem.carrier}}.png" [alt]="listItem.carriername" class="img-fluid" onError="this.src='../../../../assets/b2c/flight/flight_icon.png'"/>
                                    <div class="content">
                                      <h4>{{listItem.carriername}}</h4>
                                      <p>{{listItem.carrier}}-{{listItem.flightnumber}}&nbsp;</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="more_info_extra"><p class="mb-1"><span *ngIf="item_['list'][0].extra_info.baggage.length > 0"><mat-icon>luggage</mat-icon>{{item_['list'][0].extra_info.baggage[0].value | transformUnit}}/ Adult&nbsp;Check In Baggage</span><span *ngIf="item_['list'][0].extra_info.baggage.length === 0"><mat-icon>no_luggage</mat-icon>No Baggage</span></p><p><span><mat-icon>business_center</mat-icon><!--{{item.extra_info.hand_baggage[0].value}}-->&nbsp;7Kg (1 Piece Only) Hand Baggage/ Adult</span></p></div>
                              </div>
                              <div class="flight_body_">
                                <div class="timing_flight_">
                                  <div class="list_ list_Depart">
                                    <p class="cityName">{{listItem.origin_name}}</p>
                                    <p class="time">{{listItem.deptime | hourMinute}}</p>
                                    <p class="cityDate">{{listItem.depdate | date: 'LLL, dd yyyy'}}</p>
                                    <p class="terminal" *ngIf="listItem.depterminal !== ''">Terminal {{listItem.depterminal}}</p>
                                  </div>
                                  <div class="list_ list_Duration">
                                    <div class="duration">
                                      <img src="../../../../assets/belairtrip_assets/svg_icon/clockicon.svg" alt="" class="img-fluid clock">
                                      <p class="timeDuration">{{listItem.journeyduration | formatTime}}</p>
                                      <div class="distpoint">
                                        <span class="line"></span>
                                      </div>
                                      <p class="stopage">
                                        <!-- <ng-container *ngIf="item.layovers[0].length !== 0">{{item['flightlegs'][0].length - 1}} stop via</ng-container>
                                        <ng-container *ngFor="let list of item.layovers[0] | keyvalue">
                                          <ng-container>&nbsp;{{list.key}}</ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="item.layovers[0].length === 0">Direct Flight</ng-container> -->
                                      </p>
                                    </div>
                                  </div>
                                  <div class="list_ list_Arrive">
                                    <p class="cityName">{{listItem.destination_name}}</p>
                                    <p class="time">{{listItem.arrtime | hourMinute}}</p>
                                    <p class="cityDate">{{listItem.arrdate | date: 'LLL, dd yyyy'}}</p>
                                    <p class="terminal" *ngIf="listItem.depterminal !== ''">Terminal {{listItem.arrterminal}}</p>
                                  </div>
                                </div>
                              </div>
                              <!-- Layover -->
                              <ng-container *ngIf="listItem.stopover === true">
                                <div class="layover">
                                  <ng-container *ngFor="let list of item_['list'][0].layovers[0] | keyvalue">
                                    <ng-container *ngIf="list.key === listItem.destination">
                                      <p>Flight change · Layover&nbsp;&nbsp;<span>{{this.util.convertToNumber(list.value) | secondsToDHM}}&nbsp;({{listItem.destination}})</span></p>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngFor="let item of item_['list']">
                        <div class="FareSummarySelect" *ngIf="activeTab === 'FareSummary'">
                          <div class="flight_tab_list_details headerFlightSelect">
                            <div class="innerWrapper fare_information">
                              <div class="flight_fare_info">
                                <div class="more_info_fare">
                                  <ul>
                                    <li>Base Fare: <span>{{ (this.adultNum * item.flightfare.adultbasefare) + (this.childNum * item.flightfare.childbasefare) + (this.infantNum * item.flightfare.infantbasefare) | globalCurrency: item.flightfare.currency }}</span></li>
                                    <li>Fee & Surcharges: <span>{{ (this.adultNum * item.flightfare.adulttax) + (this.childNum * item.flightfare.childtax) + (this.infantNum * item.flightfare.infanttax) | globalCurrency: item.flightfare.currency }}</span></li>
                                    <li>Total Amount: <span>{{item.flightfare.totalnet | globalCurrency: item.flightfare.currency}}</span></li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngFor="let item of item_['list']">
                        <div class="FareRulesSelect" *ngIf="activeTab === 'FareRules'">
                          <div class="flight_tab_list_details headerFlightSelect">
                            <div class="innerWrapper fare_information">
                              <div class="flight_fare_rule">
                                <div class="more_info_rule">
                                  <ul>
                                    <li *ngIf="item.extra_info.cancel.length > 0">Airline Cancellation Fee: <span>{{item.extra_info.cancel[0].value | globalCurrency: item.flightfare.currency}}</span>
                                      <p>{{item.extra_info.cancel[0].rule}}</p>
                                    </li>
                                    <li *ngIf="item.extra_info.change.length > 0">Airline Date Change Fee: <span>{{item.extra_info.change[0].value | globalCurrency: item.flightfare.currency}}</span>
                                      <p>{{item.extra_info.change[0].rule}}</p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </section>
              </section>
              <!-- <mat-tab-group dynamicHeight animationDuration="0ms">
                <mat-tab>
                  <ng-template mat-tab-label>Flight Details</ng-template>
                  1
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>Flight Summary</ng-template>
                  2
                </mat-tab>
              </mat-tab-group> -->
            </div>
          </ng-container>
        </div>
      </section>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="this.list[0]?.totalFlight === 0">
    <app-no-flight></app-no-flight>
  </ng-container>
  <app-no-flight *ngIf="noFlightError"></app-no-flight>
</section>
<app-flight-result-loader *ngIf="isBookingLoader"></app-flight-result-loader>